import _ from 'lodash';
import es from 'vee-validate/dist/locale/es';
import VeeValidate, {Validator} from 'vee-validate';
import Validations from '../locales/Validations';
import {REGEX} from '../../shared/constants/regex';

export const CONFIG = {
  locale: 'es',
  dictionary: Validations,
  events: 'blur'
};

export const GLOBAL_SCOPE = '__global__';

Validator.addLocale(es);

Validator.extend('rfc', {
  messages: {
    es: field => 'Formato inválido'
  },
  validate: value => REGEX.rfc.test(value)
});

Validator.extend('min_files', {
  messages: {
    es: (field, args) => `Al menos ${args} archivos son requeridos.`
  },
  validate: (value, args) => _.filter(value, file => !file.hasError).length >= args
});

export default VeeValidate;